/**
 * Combine all reducers in this file and export the combined reducers.
 */

import * as Reducers from './mix';

import { ReducersMapObject } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from 'utils/history';
import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const SESSION_TOKEN_KEY = 'session:authToken';

// Wraps the token reducer so its string value is manually synced to sessionStorage.
// This survives F5 within the same tab but clears on browser close.
// We intentionally avoid persistReducer here — redux-persist corrupts primitive (string) state
// via Object.assign, turning the token string into a character-indexed object.
const rawTokenReducer = Reducers.token;
const tokenReducer = (state: string = sessionStorage.getItem(SESSION_TOKEN_KEY) || '', action: any): string => {
	const next = rawTokenReducer(state, action);
	if (next !== state) {
		if (next) sessionStorage.setItem(SESSION_TOKEN_KEY, next);
		else sessionStorage.removeItem(SESSION_TOKEN_KEY);
	}
	return next;
};

const config = {
	key: window.location.hostname,
	storage,
	// blacklist: ['loader', 'header'],
	blacklist: ['loader', 'title', 'token', 'room', 'audioRoom', 'consultationPresence'],
};

const reducersWithSessionToken = { ...Reducers, token: tokenReducer };

// @ts-ignore
const persistReducers = persistCombineReducers(config, reducersWithSessionToken as ReducersMapObject<any>);

const rootReducer = (state: any, action: any) => persistReducers(state, action);
// @ts-ignore
export default connectRouter(history)(rootReducer);
